module.exports = __webpack_public_path__ + "img/floating_default.199fa260.png";